/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Minimum_WarningInputs */



/**
* | output |
* | --- |
* | "Select at least two event groups to merge metadata" |
*
* @param {Metadata_Merge_Minimum_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_minimum_warning = /** @type {((inputs?: Metadata_Merge_Minimum_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Minimum_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez au moins deux groupes d'événements pour fusionner les métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie mindestens zwei Ereignisgruppen aus, um Metadaten zusammenzuführen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona almeno due gruppi di eventi per unire i metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите как минимум две группы событий для объединения метаданных.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione al menos dos grupos de eventos para fusionar los metadatos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择至少两个事件组以合并元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータをマージするイベントグループを少なくとも2つ選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा को मर्ज करने के लिए कम से कम दो इवेंट समूह चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione pelo menos dois grupos de eventos para mesclar metadados.")
	return /** @type {LocalizedString} */ ("Select at least two event groups to merge metadata")
});